export default function formatDateAsShort(timestamp) {
  const date = new Date(timestamp * 1000);
  const dateAtBeginingOfDay = new Date(timestamp * 1000);
  const today = new Date();
  const sixDaysAgo = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 6
  );
  let result = date.toLocaleDateString("en-GB", {
    month: "short",
    day: "2-digit",
  });

  dateAtBeginingOfDay.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (dateAtBeginingOfDay.getTime() === today.getTime()) {
    result = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } else if (dateAtBeginingOfDay.getTime() >= sixDaysAgo.getTime()) {
    result = date.toLocaleString("en-GB", { weekday: "short" });
  }

  return result;
}
